// Zástupná obrazovka sekce: název podle menu (h1 = název v menu, docs/04) a věta, ve které fázi
// plánu (docs/06) skutečná obrazovka přijde. Nahradí ji obrazovky podle `data-screen-label`.
import type { Ja } from '@ecoser/shared';
import { Link } from 'react-router';
import { PrazdnyStav } from '../komponenty/PrazdnyStav';
import { nazevSekcePodleRole } from '../shell/menu';
import { fazeSekce } from '../shell/sekce-cesty';
import './sekce.css';

export function Zastupna({ klic, ja }: { klic: string; ja: Ja }) {
  const nazev = nazevSekcePodleRole(klic, ja);
  const faze = fazeSekce(klic);
  const kdy = faze ? `fáze ${faze.faze} (krok ${faze.krok})` : 'další fáze plánu';

  return (
    <section className="sekce" data-screen-label={nazev} data-sekce={klic}>
      <h1>{nazev}</h1>
      <p className="podtitul">Obrazovka podle prototypu přijde v {kdy}.</p>
      <PrazdnyStav
        className="sekce__zastupna"
        text={`Sekce ${nazev} se připravuje — ${kdy}.`}
        akce={
          <Link to="/" className="tlacitko tlacitko--primarni">
            Zpět na Domů
          </Link>
        }
      />
    </section>
  );
}
